<script setup lang="ts">
import { useInputSalesTax } from '../../../model/additional-info/support/info-invoice-creation/input-sales-tax.hook'
import { useInputState } from '../../../model/additional-info/support/info-invoice-creation/input-state.hook'
import { useSelectCreationReason } from '../../../model/additional-info/support/info-invoice-creation/select-creation-reason.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import InputSalesTax from './info-invoice-creation/InputSalesTax.vue'
import SelectCreationReason from './info-invoice-creation/SelectCreationReason.vue'
import InputState from './info-invoice-creation/InputState.vue'

defineOptions({
  name: 'InfoInvoiceCreation',
})

const { isRequired: isRequiredCreationReason } = useSelectCreationReason()
const { isRequired: isRequiredState } = useInputState()
const { isRequired: isRequiredSalesTax } = useInputSalesTax()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      title="Creation reason"
      :required="isRequiredCreationReason"
    >
      <SelectCreationReason />
    </RowTaskInfo>
    <RowTaskInfo
      title="State"
      :required="isRequiredState"
    >
      <InputState />
    </RowTaskInfo>
    <RowTaskInfo
      title="Sales tax"
      :required="isRequiredSalesTax"
    >
      <InputSalesTax />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
